import { InputKeyPair } from 'types/common'

export const getNestedErrorMessage = (
  errors: Record<string, any>,
  inputKey: InputKeyPair,
) => {
  return errors?.[inputKey.parentKey]?.[inputKey.key]?.message
}

export const getInputErrorMessage = (
  errors: Record<string, any>,
  inputKey: Omit<InputKeyPair, 'parentKey'>,
) => {
  return errors?.[inputKey.key]?.message || ''
}
